import React from 'react';

import { featureConfigs, features, planConfigs, planFeatures, plans } from 'pages/Landings/sections/Pricing/constants';
import { Period } from 'pages/Landings/sections/Pricing/types';

import useStyles from './styles';

import CheckIcon from '../../assets/check.svg';
import Feature from '../../components/Feature';
import PlanSummary from '../../components/PlanSummary';

interface Props {
    period: Period;
    className?: string;
}

const Mobile: React.FC<Props> = ({ period, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.cards}>
                {plans.map((plan) => (
                    <div key={plan} className={classes.card}>
                        <PlanSummary plan={plan} period={period} className={classes.summary} />
                        <span className={classes.property}>
                            <CheckIcon />
                            <Feature title={`${planConfigs[plan].credits} API Credits per month`} />
                        </span>

                        {features.map((feature) =>
                            planFeatures[plan][feature] ? (
                                <span key={feature} className={classes.property}>
                                    <CheckIcon />
                                    <Feature
                                        key={feature}
                                        title={featureConfigs[feature].title}
                                        href={featureConfigs[feature].href}
                                        tooltip={featureConfigs[feature].tooltip}
                                    />
                                </span>
                            ) : null
                        )}
                    </div>
                ))}
            </div>
            <span className={classes.caption}>{'* Within purchased API Credits quota'}</span>
        </div>
    );
};

export default Mobile;
